import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  FINANCE_LIST_QUERY_KEY,
  FINANCE_PERMISSIONS,
} from '@modules/finance/constants';
import { FINANCE_MONTH_LIST_QUERY_KEY } from '@modules/finance/submodules/month-report/constants';
import { useToastStore } from '@modules/toast/store';
import { isString } from '@utils/guards';

import type { IFinanceDeductionSavePayload } from '../types';
import {
  ADMIN_FINANCE_MONTH_DEDUCTION_SAVE_URL,
  FINANCE_MONTH_DEDUCTION_QUERY_KEY,
  FINANCE_MONTH_DEDUCTION_SAVE_MUTATION_KEY,
} from '../constants';

export default function useSaveFinanceMonthDeduction(): IContextMutationResult<
  void,
  Error,
  IFinanceDeductionSavePayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IFinanceDeductionSavePayload>({
    mutationKey: [FINANCE_MONTH_DEDUCTION_SAVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      ADMIN_FINANCE_MONTH_DEDUCTION_SAVE_URL,
      payload,
      { permission: FINANCE_PERMISSIONS.CHANGE_STATUS },
    ),
    onSuccess({ queryClient }) {
      void queryClient.invalidateQueries({
        predicate: (query) => isString(query.queryKey[0]) && [
          FINANCE_MONTH_DEDUCTION_QUERY_KEY,
          FINANCE_MONTH_LIST_QUERY_KEY,
          FINANCE_LIST_QUERY_KEY,
        ].includes(query.queryKey[0]),
      });
      displayPresetToast('success');
    },
  });
}
